import { styled } from 'styled-components'

const PADDING = 16

const MapControlsOverlay = styled(Flex)`
  position: absolute;
  z-index: -1;

  top: 0px;
  left: ${PADDING}px;
  right: ${PADDING}px;
  bottom: ${PADDING}px;

  flex: 1;
  flex-direction: column;
`

export default MapControlsOverlay
